"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var icons_1 = __importDefault(require("../../../../theme/icons"));
var layout_1 = __importDefault(require("../../../../theme/layout/layout"));
function Dashboard() {
    var _a = (0, react_1.useState)(false), showModal = _a[0], setShowModal = _a[1];
    var t = (0, react_i18next_1.useTranslation)().t;
    var onClickZip = function () {
        setShowModal(true);
    };
    function ButtonGroup(name, icon, link) {
        return (react_1.default.createElement("a", { className: "dashboard-link", href: link },
            react_1.default.createElement("div", { className: "dashboard-link-background" },
                react_1.default.createElement(icons_1.default, { name: icon, width: 60, height: 60, className: "" })),
            react_1.default.createElement("div", { className: "dashboard-title" }, name)));
    }
    return (react_1.default.createElement("div", { className: "login" },
        react_1.default.createElement("div", { className: "left" }),
        react_1.default.createElement(layout_1.default, null,
            react_1.default.createElement("div", { className: "logo-container" },
                react_1.default.createElement(icons_1.default, { height: 80, name: "logo", width: 80 }),
                react_1.default.createElement(icons_1.default, { className: "icon_black", height: 80, name: "srhrlogofull", width: 150 })),
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: "button-container" },
                    ButtonGroup(t("guide"), "usage", "/auditor/guide"),
                    ButtonGroup(t("knowledge"), "education", "/auditor/education"),
                    ButtonGroup(t("services"), "service", "/auditor/service_center")),
                react_1.default.createElement("div", { className: "button-container" },
                    ButtonGroup(t("monitoring"), "myFinance", "/auditor/underConstruction"),
                    ButtonGroup(t("report"), "report", "/auditor/report"))))));
}
exports.default = Dashboard;
